module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/landing/enterprise-3e192ba7d7708a1fd97c080a7b7940eb.jpg";